<template>
    <div class="ProviderPane paper" v-observe-visibility="VisibilityChanged" style="display:flex;flex-direction:column; max-height:85vh;">
        <div ref="divtophalf">
            <h2>Providers <font-awesome-icon :icon="['fa', 'sync-alt']" v-on:click="RefreshDataTable()" class="olive-green-text pointer" /> <font-awesome-icon :icon="['fa', 'plus']" v-on:click="NewRecordShow()" class="olive-green-text pointer" /> <span v-b-tooltip.hover title="Hide/Show Filters"><font-awesome-icon :icon="ShowFilters ? 'eye' : 'eye-slash'" v-on:click="ToggleShowFilters()" class="pointer" /></span></h2>
            <form class="table-filters client-list" v-show="ShowFilters">
                <div class="row">
                    <div class="col-sm-3">
                        <div class="form-group">
                            <label>Location:</label>
                            <select class="form-control" v-model="Filters.SubProgramID" @change="RefreshDataTable()">
                                <option value="12E83DA9-E178-4DB2-9077-6097F277443A">Wraparound</option>
                                <option value="CAE7A29E-2B48-4B32-A4B8-015C0BE03702">Wraparound - San Bernardino CRT</option>
                                <option value="41870532-AB7A-445B-A690-733150960EBF">Residential</option>
                                <option value="28CD87C1-85B2-4B3B-B348-8ED0688B7F15">Desert Outpatient</option>
                                <option value="CBC3D45D-E45C-4BD5-887F-5AB87F154038">Midcounty Outpatient</option>
                                <option value="CDEEA441-E964-4D7F-ABFC-C0F19BD3FF14">Inland Crisis Response</option>
                            </select>
                        </div>
                    </div>
                    <div class="col-sm-3">
                        <div class="form-group">
                            <label>Start Date:</label>
                            <flat-pickr v-model="Filters.StartDate" class="form-control" :config="DateConfig"></flat-pickr>
                        </div>
                    </div>
                    <div class="col-sm-3">
                        <div class="form-group">
                            <label>End Date:</label>
                            <flat-pickr v-model="Filters.EndDate" class="form-control" :config="DateConfig"></flat-pickr>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-sm-4">
                        Displaying {{RowCount}} Records
                    </div>
                    <div class="col-sm-4"></div>
                    <div class="col-sm-4">
                        <div class="form-group">
                            <label>Search:</label>
                            <input type="text" v-model="search" class="form-control" @input="RedrawTable()" />
                        </div>
                    </div>
                </div>
            </form>
        </div>
        <div style="overflow:auto;">
            <vuetable :fields="TableOptions.Fields"
                      pagination-path=""
                      :api-mode="false"
                      class="vue-datatable"
                      :data-manager="DataManager"
                      ref="datatable">

                <template slot="Operations" scope="props">
                    <div class="Operations">
                        <router-link :to="{ name: 'BillingProviderProfile', params: { Id: props.rowData.Id }}">
                            {{ props.rowData.Id.slice(-8) }}
                        </router-link>
                    </div>
                </template>
            </vuetable>
        </div>
    </div>
</template>

<script>
    //import components
    import flatPickr from 'vue-flatpickr-component';
    import 'flatpickr/dist/flatpickr.css';
    import Vuetable from 'vuetable-2/src/components/Vuetable'
    import { RouterLink } from 'vue-router';

    //import icons
    import { library } from '@fortawesome/fontawesome-svg-core';
    import { faSyncAlt } from '@fortawesome/free-solid-svg-icons';
    library.add(faSyncAlt);
    import { faPlus } from '@fortawesome/free-solid-svg-icons';
    library.add(faPlus);
    import { faEye } from '@fortawesome/free-solid-svg-icons';
    library.add(faEye);
    import { faEyeSlash } from '@fortawesome/free-solid-svg-icons';
    library.add(faEyeSlash);

    //mixins
    import { TableScrollerSupport } from "../../../../mixins/TableScrollerSupport.js";

    export default {
        mixins: [TableScrollerSupport],
        created() {

        },
        beforeDestroy() {

        },
        props: [],
        data: function () {
            return {
                TableData: [],
                TargetRecord: {},
                InvoiceSchema: {
                },
                DateConfig: {
                    dateFormat: 'Y-m-d',
                    allowInput: true,
                    altInput: true,
                    altFormat: 'm/d/Y',
                },
                RowCount: 0,
                search: "",
                Filters: {

                },
                TableOptions: {
                    Fields: [
                        {
                            name: '__slot:Operations',
                            title: 'Id',
                            sortField: 'Id',
                        },
                        {
                            name: 'Id',
                            title: 'Id',
                            visible: false
                        },
                        {
                            name: 'FullName',
                            title: 'Provider',
                            sortField: 'FullName'
                        },
                        {
                            name: 'WelligentID',
                            title: 'Welligent ID',
                            sortField: 'WelligentID'
                        },
                        {
                            name: 'AvatarProviderName',
                            title: 'Avatar Provider Name',
                            sortField: 'AvatarProviderName'
                        },
                        {
                            name: 'LicenseType',
                            title: 'License',
                            sortField: 'LicenseType'
                        },
                        {
                            name: 'ProviderBillingRole',
                            title: "Billing Role",
                            sortField: 'ProviderBillingRole',
                        },
                    ]
                }
            };
        },
        methods: {
            RefreshDataTable() {
                this.GetData();
            },

            //////////////////////////
            //  API CONNECTIONS
            //////////////////////////

            //Get Invoices
            GetData() {
                this.$MasterAPI.ExecuteRequest("GET", "MentalHealth/Billing/ProviderProfile", this.Filters, this.GetDataSuccess, () => { }, true);
            },
            GetDataSuccess(response) {
                this.TableData = response.data.data;
                this.$refs.datatable.refresh();
            },
            

            //////////////////////////
            //  MISC METHODS
            //////////////////////////
            formatDate(value, fmt = 'MM/DD/YY', defaultVal = '') {
                return (value == null)
                    ? defaultVal
                    : moment(value, 'YYYY-MM-DD').format(fmt)
            },

            CheckPermission(permissionName) {
                return this.$store.getters["User.PrivateProfile.CheckPermission"](permissionName);
            },
            RedrawTable() {
                this.$refs.datatable.refresh();
            },
            DataManager(sortOrder, pagination) {
                let dataset = this.filteredList(this.TableData);
                if (dataset.length > 0) {
                    if (sortOrder.length > 0) {
                        if (sortOrder[0].direction == 'asc') {
                            var firstComp = 1;
                            var secondComp = -1;
                        } else {
                            var firstComp = -1;
                            var secondComp = 1
                        }
                        return dataset.sort((a, b) => (this.$FindProperty(a, sortOrder[0].sortField) > this.$FindProperty(b, sortOrder[0].sortField)) ? firstComp : secondComp);
                    } else {
                        return dataset;
                    }

                } else {
                    return [];
                }
            },
            filteredList(inputData) {
                let vm = this;
                let tData = inputData
                if (tData == null) {
                    return [];
                }
                let tFields = vm.$refs["datatable"].tableFields;
                let visibleData = [];
                tData.forEach(function (row, index) {
                    let rowData = [];
                    tFields.forEach(function (field) {
                        rowData.push(vm.$refs.datatable.renderNormalField(field, row));

                    })
                    if (vm.search == "" || JSON.stringify(rowData).toLowerCase().includes(vm.search.toLowerCase())) {
                        visibleData.push(inputData[index]);
                    }
                });
                vm.RowCount = visibleData.length;
                return visibleData;
            }
        },
        components: {
            Vuetable,
            flatPickr,
            RouterLink
        },
        computed: {
            BillingRoleOptions: function () {
                return this.$store.state.Options.MentalHealthBillingRoles;
            },
        },
        mounted() {
            this.Filters.StartDate = '2023-07-01';
            this.Filters.EndDate = '2024-06-30';
            this.GetData();
        }
    }
</script>

<style scoped>
    /*sticky table header*/
    /deep/ .vue-datatable thead {
        position: sticky;
        top: -1px;
        background: white;
    }
    /*no wrap text on columns*/
    /deep/ .vue-datatable tbody td {
        white-space: nowrap !important;
    }
</style>